import { SearchFilter } from '@aibees/elephant/feature/search-filters';
import { useCallback } from 'react';
import { parseCommaSeparatedValues } from '../utils';

interface UseCommaSeparatedChangeSelectionParams {
  searchInputValue: string;
  metadata?: SearchFilter['metadata'];
  onChangeSelection: (selectedItems: string[], selectedValue?: string) => void;
  setSearchInputValue: (value: string) => void;
}

export function useCommaSeparatedChangeSelection({
  searchInputValue,
  metadata,
  onChangeSelection,
  setSearchInputValue,
}: UseCommaSeparatedChangeSelectionParams) {
  return useCallback(
    (newSelectedValues: string[]) => {
      const parsedValues = parseCommaSeparatedValues(searchInputValue);
      const otherValues = newSelectedValues.filter(
        (v) => v !== searchInputValue
      );
      const allValues = metadata?.autocomplete?.multiple
        ? [
            ...otherValues,
            ...parsedValues.filter((v) => !otherValues.includes(v)),
          ]
        : [parsedValues[0]];

      onChangeSelection(
        allValues,
        metadata?.autocomplete?.multiple ? parsedValues[0] : allValues[0]
      );
      setSearchInputValue('');
    },
    [searchInputValue, metadata, onChangeSelection, setSearchInputValue]
  );
}
